interface IBrowserLocation {
	host: string;
	pathname: string;
	search: string;
	hash: string;
}

function getUrlOnTenantDomain(tenantDomain: string, location: IBrowserLocation): string | null {
	if (location.host === tenantDomain) {
		return null;
	}

	return `https://${tenantDomain}${location.pathname}${location.search}${location.hash}`;
}

function redirectTo(url: string) {
	window.location.replace(url);
}

export default {
	getUrlOnTenantDomain,
	redirectTo,
};
